import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Agencia } from '../interfaces/agencia';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AgenciaService {

  readonly path = '/agencia';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  create(): Observable<Agencia> {
    return this.http.post<Agencia>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(agencia: Agencia): Observable<Agencia> {
    return this.http.put<Agencia>(`${this.jwtAuthService.apiUrl + this.path}`, agencia);
  }

  getAgencia(id: number ): Observable<Agencia> {
    return this.http.get<Agencia>(`${this.jwtAuthService.apiUrl + this.path}/?AgenciaId=${id}`);
  }

  getAgenciaPage(page?: number, size?: number): Observable<PageResult<Agencia>> {
    return this.http.get<PageResult<Agencia>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getAgenciaPageSearch(page?: number, size?: number,  search?: string): Observable<PageResult<Agencia>> {
    return this.http.get<PageResult<Agencia>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}`);
  }

  deleteAgencia(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }


}
